export default __webpack_public_path__ + "static/media/num-icon2.c320dc66.svg";